import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-765bff25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Text" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "Caption" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "Caption" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "Caption" }
const _hoisted_8 = {
  key: 0,
  class: "StatusGroup"
}
const _hoisted_9 = {
  key: 1,
  class: "StatusLabel Unknown"
}
const _hoisted_10 = {
  key: 2,
  class: "StatusLabel Unknown"
}
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTip = _resolveComponent("ToolTip")!
  const _component_InlineSVG = _resolveComponent("InlineSVG")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["SampleStatus", _ctx.sample.getOverallResultClass()])
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.sample.sampleTypeID), 1)
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_ctx.title), 1),
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.captionText), 1),
      (_ctx.equivalentsText)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.equivalentsText), 1)
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.sampleType === 'existing')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.mixWB('REFERENCE')) + ": " + _toDisplayString(_ctx.sample.existingResultExplanation), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.sampleType !== 'postponed')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_ctx.sampleType === 'existing')
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["StatusLabel", _ctx.sample.getOverallResultClass()])
              }, _toDisplayString(_ctx.sample.getResultLabel()), 3))
            : (_ctx.sample.options.hasMissingTestResult)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.mixWB('STATUS_AWAITING_TEST_RESULTS')), 1))
              : (_ctx.sample.options.isAalholmSlotDustSample)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.mixWB('SEE_COMMENTS')), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["StatusLabel Mobile", _ctx.sample.getOverallResultClass()])
                    }, _toDisplayString(_ctx.sample.getResultLabel()), 3),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summmaryDots, (dot) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: dot.id,
                        class: "StatusWrapper"
                      }, [
                        _createVNode(_component_ToolTip, { placement: "below" }, _createSlots({
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["Status", dot.class])
                            }, null, 2)
                          ]),
                          _: 2
                        }, [
                          (dot.result !== null)
                            ? {
                                name: "message",
                                fn: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dot.analysisTests, (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: item.id,
                                      class: "StatusToolTipLine"
                                    }, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["Status", item.class])
                                      }, null, 2),
                                      _createElementVNode("span", {
                                        innerHTML: item.text
                                      }, null, 8, _hoisted_11)
                                    ]))
                                  }), 128))
                                ])
                              }
                            : undefined
                        ]), 1024)
                      ]))
                    }), 128))
                  ], 64))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_InlineSVG, {
      class: "Icon",
      src: require('@/assets/svg/angle-right.svg')
    }, null, 8, ["src"])
  ], 64))
}